import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getUserDetails } from "../Services/profile.service";
import { loginUser } from "../Services/auth.service";


interface UserState {
  isLoggedIn: boolean;
  user: Record<string, any>;
  uid: any;
  token: String;
  loading: boolean;
  error: string | null;
  tokensRemaining:any;
  isPaymentDone:any;
  role: string;
  //userImage:any;
}

// Define the initial state
const initialState: UserState = {
  isLoggedIn: !! localStorage.getItem("auth-token"),
  user: {},
  uid: localStorage.getItem("id"),
  token: "",
  loading: false,
  error: "",
  tokensRemaining:"",
  isPaymentDone:false,
  role: localStorage.getItem("role") || "",
  //userImage:"",
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {

    login(state, action: PayloadAction<Record<string, any>>) {
      state.isLoggedIn = true;
      state.uid = action.payload.data.id;
      state.token = action.payload.data.access_token;
      state.role = action.payload.data.role || "";
      localStorage.setItem("id", action.payload.data.id);
      localStorage.setItem("role", action.payload.data.role || "");
      localStorage.setItem("auth-token", action.payload.data.access_token);
      //state.tokensRemaining=action.payload.data.free_tokens;
    },

    setUser(state, action: PayloadAction<Record<string, any>>) {
      state.user = action.payload.data;
    },

    setIsPaymentDone(state) {
      state.isPaymentDone = !state.isPaymentDone;
    },
    
    logout(state) {
      state.isLoggedIn = false;
      state.role = "";
      state.uid = null;
      localStorage.removeItem("auth-token");
      localStorage.removeItem("role");
      localStorage.removeItem("id");
    },
    syncLogin(state, action: PayloadAction<{ id: string | null; role: string | null }>) {
      state.isLoggedIn = !!localStorage.getItem("auth-token");
      state.uid = action.payload.id;
      state.role = action.payload.role || "";
    },
    reduceToken(state){
      state.tokensRemaining=state.tokensRemaining-1;
    }
    
  },

  extraReducers: (builder) => {
    builder
      .addCase(getUserDetails.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.user = action.payload.data;
        state.tokensRemaining=action.payload.data.remaining_tokens;
      })
      .addCase(loginUser.fulfilled,(state)=>{
        localStorage.setItem("tour","true")
      })
    
  },


});


export default userSlice.reducer;
export const { login, setUser , logout,reduceToken,setIsPaymentDone, syncLogin } = userSlice.actions;
